module.exports = __webpack_public_path__ + "971a768dac142dd8a2ea2a409dac8bb0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/info-trader-square-gray.png
// module id = 2750
// module chunks = 0